<div class="account-shell__content">
  <div class="account-shell__content-wrapper pl-3 pr-3">
    <div class="grid align-items-end" [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-3'">
      <div class="col-4 col-sm-12 no-padding">
        <div class="account-shell__forms-input" [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'mt-2' : 'pr-2'">
          <div class="ui-input__placeholder"><p>С даты</p></div>
          <div class="ui-input ui-input__text"><input type="date" [(ngModel)]="from" [ngModelOptions]="{standalone: true}" /></div>
        </div>
      </div>
      <div class="col-4 col-sm-12 no-padding">
        <div class="account-shell__forms-input" [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'mt-2' : 'pl-2 pr-2'">
          <div class="ui-input__placeholder"><p>По дату</p></div>
          <div class="ui-input ui-input__text"><input type="date" [(ngModel)]="to" [ngModelOptions]="{standalone: true}" /></div>
        </div>
      </div>
      <div class="col-4 col-sm-12 no-padding">
        <div class="account-shell__forms-input" [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'mt-2' : 'pl-2'">
          <div class="ui-input__placeholder"><p>Статус</p></div>
          <p-dropdown
            [options]="statusOptions"
            optionLabel="name"
            optionValue="value"
            [(ngModel)]="status"
            [ngModelOptions]="{standalone: true}"
            [showClear]="false"
            styleClass="p-dropdown__bulletins">
          </p-dropdown>
        </div>
      </div>
    </div>

    <div class="grid mb-3">
      <div class="col-auto pr-2">
        <button type="button" class="ui-buttons ui-buttons__blue-large" (click)="onApplyFilters()" [disabled]="loading">Применить</button>
      </div>
      <div class="col-auto">
        <button type="button" class="ui-buttons ui-buttons__light-large" (click)="onResetFilters()" [disabled]="loading">Сбросить</button>
      </div>
    </div>

    <p class="txt-caption" *ngIf="loadError">{{ loadError }}</p>
    <div class="grid justify-content-center py-4" *ngIf="loading">
      <div class="ui-loader ui-loader__page-light"></div>
    </div>

    <div *ngIf="!loading && !loadError">
      <div class="account-invitations__empty txt-caption" *ngIf="!items.length">Приглашений не найдено.</div>

      <div class="account-invitations__list" *ngIf="items.length">
        <div class="account-invitations__item" *ngFor="let item of items">
          <div class="account-invitations__row">
            <div class="account-invitations__avatar-wrap">
              <img
                *ngIf="customerPhoto(item) as photo"
                [src]="photo"
                alt=""
                class="account-invitations__avatar" />
              <div *ngIf="!customerPhoto(item)" class="account-invitations__avatar account-invitations__avatar-placeholder">
                <span class="mr-icon mr-icon-user">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </span>
              </div>
            </div>

            <div class="account-invitations__content">
              <h5 class="account-invitations__name">{{ customerName(item) }}</h5>
              <p class="txt-caption account-invitations__date">Дата приглашения: {{ formatDate(item.createdAt) }}</p>
              <p class="txt-caption account-invitations__message" *ngIf="item.message">Сообщение: {{ item.message }}</p>
              <p class="txt-caption account-invitations__conditions">Условия: {{ conditionsSummary(item) }}</p>
            </div>

            <div class="account-invitations__meta">
              <span class="account-invitations__status" [ngClass]="'account-invitations__status_' + statusClass(item.status)">
                {{ statusLabel(item.status) }}
              </span>
              <div class="account-invitations__actions">
                <button
                  *ngIf="canAcceptOrDecline(item)"
                  type="button"
                  class="ui-buttons ui-buttons__blue-small"
                  (click)="confirmAccept(item)"
                  [disabled]="actionDisabled(item)">
                  Принять
                </button>
                <button
                  *ngIf="canAcceptOrDecline(item)"
                  type="button"
                  class="ui-buttons ui-buttons__light-small"
                  (click)="confirmDecline(item)"
                  [disabled]="actionDisabled(item)">
                  Отклонить
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid align-items-center mt-3" *ngIf="items.length && showPager">
        <div class="col-auto pr-2">
          <button type="button" class="ui-buttons ui-buttons__light-small" (click)="onPrevPage()" [disabled]="loading || page <= 1">Назад</button>
        </div>
        <div class="col-auto pr-2">
          <p class="txt-caption mb-0">Страница {{ page }}</p>
        </div>
        <div class="col-auto">
          <button type="button" class="ui-buttons ui-buttons__light-small" (click)="onNextPage()" [disabled]="loading || !hasMore">Вперед</button>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog
  key="invitations"
  [appendTo]="'body'"
  [styleClass]="'p-dialog__confirm'">
</p-confirmDialog>
